import {styled} from "@reside/ui";
export const MenuContainer = styled.div`
  align-self: flex-start;
  margin-bottom: 15px;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid ${({theme}) => theme.color.gray10};
  background: ${({theme}) => theme.color.white};
`;
